import { useDroppable } from '@dnd-kit/core';
import { useMemo } from 'react';
import { transparentImageOnImageDropzoneInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { drawer, label } from './molecule.drawer.style.js';
import { DraggableTile } from './tile/atom.draggable.js';
import { TransparentImageOnImageTile } from './tile/atom.tile.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TileDrawer(props) {
  const {
    setNodeRef
  } = useDroppable({
    id: "drawer",
    disabled: !props.draggable
  });
  const context = useTaskContext();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => Object.values(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(value => transparentImageOnImageDropzoneInput.entry.asTypeSafe(value)).filter(it => !!it)
  });
  const sortedTiles = useMemo(() => {
    if (context !== "input") {
      return props.tiles;
    }
    return [...props.tiles].sort((a, b) => {
      const isAPlaced = inputEntry?.some(it => it.tileId === a.id);
      const isBPlaced = inputEntry?.some(it => it.tileId === b.id);
      if (isAPlaced) {
        return 1;
      }
      if (isBPlaced) {
        return -1;
      }
      return 0;
    });
  }, [context, inputEntry, props.tiles]);
  return /*#__PURE__*/jsxs("div", {
    className: drawer,
    ref: setNodeRef,
    children: [/*#__PURE__*/jsxs("span", {
      className: label,
      children: [props.tiles.length, " brik", props.tiles.length !== 1 ? "ker" : ""]
    }), sortedTiles.map(tile => props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
      tile: tile,
      context: "drawer",
      state: "input",
      taskEntryKey: props.taskEntryKey,
      isDraggingItem: tile.id === props.draggedTileId
    }, tile.id) : /*#__PURE__*/jsx(TransparentImageOnImageTile, {
      taskEntryKey: props.taskEntryKey,
      context: "drawer",
      state: "placed",
      tile: tile
    }, tile.id))]
  });
}

export { TileDrawer };
//# sourceMappingURL=molecule.drawer.js.map
